import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-lg-4 col-sm-4" }
const _hoisted_6 = { class: "col-lg-4 col-sm-4" }
const _hoisted_7 = { class: "col-lg-4 col-sm-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-xxl-3" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-xxl-12 col-md-6 col-lg-4" }
const _hoisted_12 = { class: "col-xxl-12 col-md-6 col-lg-4" }
const _hoisted_13 = { class: "col-xxl-12 col-md-6 col-lg-4" }
const _hoisted_14 = { class: "col-xxl-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeBack = _resolveComponent("WelcomeBack")!
  const _component_TotalProjects = _resolveComponent("TotalProjects")!
  const _component_TotalOrders = _resolveComponent("TotalOrders")!
  const _component_TotalRevenue = _resolveComponent("TotalRevenue")!
  const _component_ProfileIntro = _resolveComponent("ProfileIntro")!
  const _component_ProfileInformation = _resolveComponent("ProfileInformation")!
  const _component_AdditionalInformation = _resolveComponent("AdditionalInformation")!
  const _component_ProjectsAnalysisChart = _resolveComponent("ProjectsAnalysisChart")!
  const _component_ToDoList = _resolveComponent("ToDoList")!
  const _component_RecentActivity = _resolveComponent("RecentActivity")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_WelcomeBack)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_TotalProjects)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_TotalOrders)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_TotalRevenue)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_ProfileIntro)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_ProfileInformation)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_AdditionalInformation)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_ProjectsAnalysisChart),
        _createVNode(_component_ToDoList),
        _createVNode(_component_RecentActivity)
      ])
    ])
  ]))
}